import { OtpValidateAdapter } from '../../../adapter';

export default async function OtpValidateUseCase(event) {
    console.log('OtpValidateUseCase: ', event);
    // const { loanAccountNumber, type, otp } = event;
    const { loanAccountNumber, mobileNo, email, type, otp } = event;

    const url = window.location.href;
    const isLocalhost = url.includes('localhost') || url.includes('hcc.dev.bpimsapps.com');
    const isUAT = url.includes('hcc.uat.bpimsapps.com');
    const isProd = url.includes('homeprotectionclaims.bpims.com');
    const [, stage, , flag] = url.split('.');

    // prepare data
    const endpoint = isLocalhost
        ? 'https://partners-api.dev.bpimsapps.com/v1/otp/validate'
        : isUAT
        ? 'https://partners-api.uat.bpimsapps.com/v1/otp/validate'
        : isProd
        ? `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/otp/validate`
        : `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/otp/validate`;

    // prepare data
    // const requestUrl = 'https://partners-api.dev.bpimsapps.com/v1/otp/validate';

    let payload;

    if (Object.keys(event).length == 2 || loanAccountNumber) {
        payload = {
            coicNo: !!loanAccountNumber ? loanAccountNumber : undefined,
            type: type ?? 'email',
            otp: !!otp ? otp : undefined,
            page: 1,
            size: 5
        };
    }

    if (Object.keys(event).length == 4 && mobileNo && email) {
        payload = {
            mobileNo: !!mobileNo ? mobileNo : undefined,
            email: !!email ? email : undefined,
            type: type ?? 'email',
            otp: !!otp ? otp : undefined,
            page: 1,
            size: 5
        };
    }

    // handle request
    const result = await OtpValidateAdapter(endpoint, JSON.stringify(payload));

    return result;
}
